module.exports = __webpack_public_path__ + "ui-static/img/alerts-no-items_dark.a9f70798.svg";